// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./reacttags.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/arkibal-display-medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/arkibal-display-medium-italic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/unsplash.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
    font-family: 'Asap';
    margin: 0px;
    padding: 0px;
}

html, body {
    height: 100%;
}

@font-face {
    font-family: 'Arkibal';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
}

@font-face {
    font-family: 'Arkibal';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
    font-style: italic;
}

h1, h2, h3, h4, h5, h6 {
    font-family: 'Arkibal';
}
#container {
    background-color: #E3F2FF;
    min-height: 100%;
    min-width: 100%;
}

.width100 {
    min-width: 100%;
}

.baseAppDiv {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.homeNavContainer {
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
}

.reactRouterDiv {
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
}

.navBar {
    z-index: 10;
    background-color: #111033;
}

.navBarClipNotesLogo {
    height: 50px;
    margin-top: -7px;
    margin-bottom: -7px;
}

.centeringContainer {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    margin: 1em;
}

.centeredContainer {
    max-width: 500px;
}

.loginSignUpLogo{
    max-width: 100%;
    margin-bottom: 2em;
    min-width: 0;
}

.formArea {
    padding: 1em;
    border: 1px solid #BEBBB5;
    background-color: white;
    border-radius: 10px;
}

.loginSignUpForm {
    padding: 2em;
}

.comingSoon {
    background-position: center center;
    background-size: cover;
    height: auto;
    left: 0;
    min-height: 100%;
    min-width: 100%;
    position: absolute;
    top: 0;
    width: auto;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    z-index: 0;
}

.vimeo-wrapper {
   position: fixed;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   z-index: -1;
   pointer-events: none;
   overflow: hidden;
}
.vimeo-wrapper iframe {
   width: 100vw;
   height: 56.25vw; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
   min-height: 100vh;
   min-width: 177.77vh; /* Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
   position: absolute;
   top: 50%;
   left: 50%;
   transform: translate(-50%, -50%);
}

.redBorder {
    border: 4px solid red;
}

.blackOverlay {
    position: fixed;
    opacity: 1;
    background-color: rgba(0, 0, 0, 0.6);
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index: -1;
}

/* All the Text modifications for landing page*/
.landingContainer {
    width: 100%;
    height: 100%;
    padding-right: 1em;
    padding-left: 1em;
    margin-right: 0px;
    margin-left: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.textLogo {
    color: white;
    font-family: 'Arkibal'
}

.comingSoonClipNotesLogo {
    display: block;
    max-width: 600px;
    width: auto;
    height: auto;
}

.textLogo:hover {
    color: white;
}

.textLogo:visited {
    color: white;
}

.header {
    font-size: 84px;
    font-weight: 100;
    color: white;
}

.spacing {
    margin-bottom: 70px;
}

.tagline {
    color: white;
    font-size: 28px;
}

.footer {
    position: absolute;
    bottom: 0;
    left: center;
    color: white;
}

/* Videoviewer and More  */
.tagFilter {
    margin: 3px;
}

/* This is the left column of the Video Player*/
.videoViewer {
    display: flex;
}

.videoViewerRow {
    flex: 1;
}

.videoViewerLeftColumn {
}

.sticky-outer-wrapper {
    flex: 1;
    height: 100%;
    display: flex;
    padding: 0;
}

.sticky-inner-wrapper {
    flex: 1;
    height: 100%;
    width: 100%;
    padding: 0 !important;
}

.videoPlayerContainer {
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
}

.videoPlayer {
    flex: 1;
    padding: 0;
    height: 56.25vw;
}

.videoTitle {
    margin-top: 5px;
    margin-bottom: 5px;
    font-size: 1.5em;
}

.videoPlayerControls {
    padding: 0.5em 1em 0.5em 1em;
    margin-top: 0em;
    border: 1px solid #BEBBB5;
    background-color: white;
    border-radius: 10px;
}

.currentTime {
    position: absolute;
}

.playbackTimeRow {
    align-items: center;
    text-align: center;
    padding-top: .5em;
    margin-bottom: .5em;
}

.timeBox {
    display: inline-block;
    width: 90px;
    margin: -0.5em 3em -0.5em 3em;
    border: 2px solid grey;
    border-radius: 10px;
    padding: .25em 1em .25em 1em;
}

.quickSetButtonRow {
    align-items: center;
    text-align: center;
}

.quickSetButtonGroup {
    margin: 0em 2em 0em 2em;
}

.unknownPlayerControls {
    align-items: center;
    text-align: center;
}

.unknownPlayerControlsImage {
    max-height: 100px;
}

.imgCenter {
    margin: 0 auto;
    display: block;
}

/* This is the right column of the Video Player*/
.videoViewerRightColumn {
    flex: 1;
    padding-right: 2em;
    padding-top: 1em;
    padding-bottom: 1em;
    margin-bottom: 0em;
}

.clipControlsContainer {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    padding: 1em;
    border-top: 1px solid #BEBBB5;
    border-bottom: 1px solid #BEBBB5;
    background-color: white;
}

.clipControlsContainerActive {
    outline: none;
    border-color: #BEBBB5;
    box-shadow: 0 0 10px rgba(0,0,0,0.5);
}

.clipControlsTopFixed {
}

.nextPreviousButtons {
    text-align: right;
}

.clipControlsMidScroll {
    flex: 1;
    position: relative;
    padding: 5px;

}

.clipControlsBottomFixed {
    margin-top: 1em;
}

.clipControlsCreateClipForms {
    flex: 9;
}

.clipCreationFormContainer {
    padding: 0em 1em 0em 1em;
    display: flex;
    flex: 1;
    flex-direction: column;
}

.videoViewerMobileCTA {
    padding: 1em;
    text-align: center;
    align-content: center;
}

.videoClip {
    cursor: pointer;
    white-space: pre-wrap;
    margin-bottom: 1em;
    width: 100%;
    box-shadow: 3px 5px 8px 1px rgba(0,0,0,0.1);
    display: flex;
    container-type: inline-size;
    border-radius: 10px !important;
}
.videoClipTimestamp {
    color: #007bff;
    margin-top: 8px;
    margin-bottom: 8px;
    font-weight: bold;
}

.videoClip:hover {
    box-shadow: 3px 5px 8px 1px rgba(0,0,0,0.5)
}

.dropdownDiv {
    position: relative;
    z-index: 4;
}

.videoClipDropdown {
    position: absolute;
    top: 1em;
    right: 1em;
}

.button {
    padding: 0px 5px 0px 5px;
}

input[type=range]::-webkit-slider-thumb {
    cursor: move;
    cursor: grab;
}

input[type=range]::-webkit-slider-thumb:active {
    cursor: grabbing;
}

input[type=range]::-moz-range-thumb {
    cursor: move;
    cursor: grab;
}

input[type=range]::-moz-range-thumb:active {
    cursor: grabbing;
}


/* My Videos CSS */
.myVideos {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    min-width: 100%;
    padding-top: 1em;
    padding-bottom: 1em;
}

.requiredForm label:after {
    color: #e32;
    content: ' *';
    display: inline;
    font-weight: bold;
}


.videoCards {
    box-shadow: 3px 5px 8px 1px rgba(0,0,0,0.1);
    max-width: 75vw;
    margin-bottom: 1em;
    border-radius: 10px !important;
}

.videoCards:hover {
    box-shadow: 3px 5px 8px 1px rgba(0,0,0,0.5)
}

.videoCardImageDiv {
    width: 100%;
    overflow: hidden;
    margin: 0;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}

.videoCardImage {
    display: block;
    width: 100%;
    margin:-10% 0;
}

/*My ClipNotes CSS */
.myClipNotes {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    padding: 1em;
}

.card .card-header {
    padding: 0;
    height: 100%;
    border: 0px;
}

.videoClipMagic {
    flex-direction: column;
}


.videoClipSourceInfo {
    flex-direction: row;
    overflow: hidden;
}

.thumbnailSection {
    flex-grow: 1;
    max-width: 20%;
}

.titleSection {
    flex: 20;
    font-size: 80%;
}

.videoClipImageDiv {
    overflow: hidden;
    display: flex;
    margin: 0;
    border-top-left-radius: 10px;
}

.videoClipImage {
    width: 100%;
    margin:-10% 0;
}

.videoClipTitle {
    padding: 0.5em 0em 0em 0.5em;
}

.selectDropdown {
    z-index: 5;
    margin-top: 1em;
    margin-bottom: 1em;
}

/* Buttons */
.playbackSpeedButton {
    margin: 1px;
}

.setTimeButton {
    height: 90%;
    white-space: nowrap;
    margin: 1px;
}

.submitClipButton {
    margin-top: 10px;
}


/* Media Queries for Responsiveness */
@media only screen and (max-width: 767px) {
    .container {
        max-width: 767px;
    }

    .videoPlayerControls {
        display: none;
    }

    .clipControlsBottomFixed {
        display: none !important;
    }

    .videoCards {
        margin: 1em;
    }

    .homeNavContainer {
        padding-bottom: 3em;
    }
}

@media only screen and (min-width: 768px) {
    .myVideos {
        padding: 2em;
    }

    .videoClipMagic {
        flex-direction: row;
    }

    .videoClipSourceInfo {
        flex-direction: column;
        max-height: none;
        height: 100%;
        max-width: 20em;
    }

    .videoInfoColumn {
        -ms-flex: 0 0 16.666667%;
        flex: 0 0 16.666667%;
        max-width: 16.666667%;
        flex-grow: 1;
    }

    .thumbnailSection {
        flex-grow: unset;
        min-width: 100%;
    }

    @container (inline-size < 700px) {
        .videoClipMagic {
            flex-direction: column;
        }

        .videoInfoColumn {
            max-width: 100%;
        }

        .videoClipSourceInfo {
            flex-direction: row;
        }

        .thumbnailSection {
            min-width: 30%;
        }
    }

    .videoClipColumn {
        display: flex;
        flex-direction: column;
        flex: 3;
    }

    .videoClipCardBody {
        flex-grow: 1;
    }

    .card .card-header {
        border-right: 1px solid #d2d3d4;
    }

    .videoViewer {
        flex: 1;
    }

    .videoPlayer {
        padding: 1em 1em 0em 1em;
        height: auto;
        border-radius: 10px;
        overflow: hidden;
    }

    .videoPlayerControls {
        margin-bottom: 1em;
    }

    .clipControlsContainer {
        margin: 0em 1em 0em 0em;
        padding: 1em;
        border: 1px solid #BEBBB5;
        border-radius: 10px;
    }

    .clipControlsMidScroll {
        padding: 0em 1em 0em 1em;
        overflow: auto;
        min-height: 300px;
    }

    .clipScrollDivHack {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    .videoViewerMobileCTA {
        display: none !important;
    }

    .videoCards {
        max-width: 18rem;
        margin: 1em;
    }

    .myClipNotes {
        padding: 2em;
    }
}
`, "",{"version":3,"sources":["webpack://./css/style.css"],"names":[],"mappings":"AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,+DAAkE;AACtE;;AAEA;IACI,sBAAsB;IACtB,+DAAyE;IACzE,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,OAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,OAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,YAAY;IACZ,OAAO;IACP,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,yDAA6C;IAC7C,UAAU;AACd;;AAEA;GACG,eAAe;GACf,MAAM;GACN,OAAO;GACP,WAAW;GACX,YAAY;GACZ,WAAW;GACX,oBAAoB;GACpB,gBAAgB;AACnB;AACA;GACG,YAAY;GACZ,eAAe,EAAE,gDAAgD;GACjE,iBAAiB;GACjB,mBAAmB,EAAE,iDAAiD;GACtE,kBAAkB;GAClB,QAAQ;GACR,SAAS;GACT,gCAAgC;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,oCAAoC;IACpC,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA,+CAA+C;AAC/C;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,YAAY;AAChB;;AAEA,0BAA0B;AAC1B;IACI,WAAW;AACf;;AAEA,+CAA+C;AAC/C;IACI,aAAa;AACjB;;AAEA;IACI,OAAO;AACX;;AAEA;AACA;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,aAAa;IACb,UAAU;AACd;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,OAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,OAAO;IACP,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,6BAA6B;IAC7B,sBAAsB;IACtB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA,gDAAgD;AAChD;IACI,OAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,gCAAgC;IAChC,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;AACA;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,kBAAkB;IAClB,YAAY;;AAEhB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,OAAO;IACP,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,2CAA2C;IAC3C,aAAa;IACb,2BAA2B;IAC3B,8BAA8B;AAClC;AACA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA,kBAAkB;AAClB;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,iBAAiB;AACrB;;;AAGA;IACI,2CAA2C;IAC3C,eAAe;IACf,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,aAAa;AACjB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;;AAGA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;AACtB;;AAEA,YAAY;AACZ;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;;AAGA,qCAAqC;AACrC;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;QAChB,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;QACrB,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI;YACI,sBAAsB;QAC1B;;QAEA;YACI,eAAe;QACnB;;QAEA;YACI,mBAAmB;QACvB;;QAEA;YACI,cAAc;QAClB;IACJ;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,OAAO;IACX;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,OAAO;IACX;;IAEA;QACI,wBAAwB;QACxB,YAAY;QACZ,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;QACvB,YAAY;QACZ,yBAAyB;QACzB,mBAAmB;IACvB;;IAEA;QACI,wBAAwB;QACxB,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,QAAQ;QACR,SAAS;IACb;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":["@import url(\"reacttags.css\");\n\n* {\n    box-sizing: border-box;\n    font-family: 'Asap';\n    margin: 0px;\n    padding: 0px;\n}\n\nhtml, body {\n    height: 100%;\n}\n\n@font-face {\n    font-family: 'Arkibal';\n    src: url('../fonts/arkibal-display-medium.otf') format('opentype');\n}\n\n@font-face {\n    font-family: 'Arkibal';\n    src: url('../fonts/arkibal-display-medium-italic.otf') format('opentype');\n    font-style: italic;\n}\n\nh1, h2, h3, h4, h5, h6 {\n    font-family: 'Arkibal';\n}\n#container {\n    background-color: #E3F2FF;\n    min-height: 100%;\n    min-width: 100%;\n}\n\n.width100 {\n    min-width: 100%;\n}\n\n.baseAppDiv {\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n}\n\n.homeNavContainer {\n    height: 100%;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n.reactRouterDiv {\n    height: 100%;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n.navBar {\n    z-index: 10;\n    background-color: #111033;\n}\n\n.navBarClipNotesLogo {\n    height: 50px;\n    margin-top: -7px;\n    margin-bottom: -7px;\n}\n\n.centeringContainer {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    justify-content: center;\n    margin: 1em;\n}\n\n.centeredContainer {\n    max-width: 500px;\n}\n\n.loginSignUpLogo{\n    max-width: 100%;\n    margin-bottom: 2em;\n    min-width: 0;\n}\n\n.formArea {\n    padding: 1em;\n    border: 1px solid #BEBBB5;\n    background-color: white;\n    border-radius: 10px;\n}\n\n.loginSignUpForm {\n    padding: 2em;\n}\n\n.comingSoon {\n    background-position: center center;\n    background-size: cover;\n    height: auto;\n    left: 0;\n    min-height: 100%;\n    min-width: 100%;\n    position: absolute;\n    top: 0;\n    width: auto;\n    background-image: url(../images/unsplash.jpg);\n    z-index: 0;\n}\n\n.vimeo-wrapper {\n   position: fixed;\n   top: 0;\n   left: 0;\n   width: 100%;\n   height: 100%;\n   z-index: -1;\n   pointer-events: none;\n   overflow: hidden;\n}\n.vimeo-wrapper iframe {\n   width: 100vw;\n   height: 56.25vw; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */\n   min-height: 100vh;\n   min-width: 177.77vh; /* Given a 16:9 aspect ratio, 16/9*100 = 177.77 */\n   position: absolute;\n   top: 50%;\n   left: 50%;\n   transform: translate(-50%, -50%);\n}\n\n.redBorder {\n    border: 4px solid red;\n}\n\n.blackOverlay {\n    position: fixed;\n    opacity: 1;\n    background-color: rgba(0, 0, 0, 0.6);\n    left: 0px;\n    top: 0px;\n    width: 100%;\n    height: 100%;\n    z-index: -1;\n}\n\n/* All the Text modifications for landing page*/\n.landingContainer {\n    width: 100%;\n    height: 100%;\n    padding-right: 1em;\n    padding-left: 1em;\n    margin-right: 0px;\n    margin-left: 0px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n}\n\n.textLogo {\n    color: white;\n    font-family: 'Arkibal'\n}\n\n.comingSoonClipNotesLogo {\n    display: block;\n    max-width: 600px;\n    width: auto;\n    height: auto;\n}\n\n.textLogo:hover {\n    color: white;\n}\n\n.textLogo:visited {\n    color: white;\n}\n\n.header {\n    font-size: 84px;\n    font-weight: 100;\n    color: white;\n}\n\n.spacing {\n    margin-bottom: 70px;\n}\n\n.tagline {\n    color: white;\n    font-size: 28px;\n}\n\n.footer {\n    position: absolute;\n    bottom: 0;\n    left: center;\n    color: white;\n}\n\n/* Videoviewer and More  */\n.tagFilter {\n    margin: 3px;\n}\n\n/* This is the left column of the Video Player*/\n.videoViewer {\n    display: flex;\n}\n\n.videoViewerRow {\n    flex: 1;\n}\n\n.videoViewerLeftColumn {\n}\n\n.sticky-outer-wrapper {\n    flex: 1;\n    height: 100%;\n    display: flex;\n    padding: 0;\n}\n\n.sticky-inner-wrapper {\n    flex: 1;\n    height: 100%;\n    width: 100%;\n    padding: 0 !important;\n}\n\n.videoPlayerContainer {\n    height: 100%;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n.videoPlayer {\n    flex: 1;\n    padding: 0;\n    height: 56.25vw;\n}\n\n.videoTitle {\n    margin-top: 5px;\n    margin-bottom: 5px;\n    font-size: 1.5em;\n}\n\n.videoPlayerControls {\n    padding: 0.5em 1em 0.5em 1em;\n    margin-top: 0em;\n    border: 1px solid #BEBBB5;\n    background-color: white;\n    border-radius: 10px;\n}\n\n.currentTime {\n    position: absolute;\n}\n\n.playbackTimeRow {\n    align-items: center;\n    text-align: center;\n    padding-top: .5em;\n    margin-bottom: .5em;\n}\n\n.timeBox {\n    display: inline-block;\n    width: 90px;\n    margin: -0.5em 3em -0.5em 3em;\n    border: 2px solid grey;\n    border-radius: 10px;\n    padding: .25em 1em .25em 1em;\n}\n\n.quickSetButtonRow {\n    align-items: center;\n    text-align: center;\n}\n\n.quickSetButtonGroup {\n    margin: 0em 2em 0em 2em;\n}\n\n.unknownPlayerControls {\n    align-items: center;\n    text-align: center;\n}\n\n.unknownPlayerControlsImage {\n    max-height: 100px;\n}\n\n.imgCenter {\n    margin: 0 auto;\n    display: block;\n}\n\n/* This is the right column of the Video Player*/\n.videoViewerRightColumn {\n    flex: 1;\n    padding-right: 2em;\n    padding-top: 1em;\n    padding-bottom: 1em;\n    margin-bottom: 0em;\n}\n\n.clipControlsContainer {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    height: 100%;\n    padding: 1em;\n    border-top: 1px solid #BEBBB5;\n    border-bottom: 1px solid #BEBBB5;\n    background-color: white;\n}\n\n.clipControlsContainerActive {\n    outline: none;\n    border-color: #BEBBB5;\n    box-shadow: 0 0 10px rgba(0,0,0,0.5);\n}\n\n.clipControlsTopFixed {\n}\n\n.nextPreviousButtons {\n    text-align: right;\n}\n\n.clipControlsMidScroll {\n    flex: 1;\n    position: relative;\n    padding: 5px;\n\n}\n\n.clipControlsBottomFixed {\n    margin-top: 1em;\n}\n\n.clipControlsCreateClipForms {\n    flex: 9;\n}\n\n.clipCreationFormContainer {\n    padding: 0em 1em 0em 1em;\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n}\n\n.videoViewerMobileCTA {\n    padding: 1em;\n    text-align: center;\n    align-content: center;\n}\n\n.videoClip {\n    cursor: pointer;\n    white-space: pre-wrap;\n    margin-bottom: 1em;\n    width: 100%;\n    box-shadow: 3px 5px 8px 1px rgba(0,0,0,0.1);\n    display: flex;\n    container-type: inline-size;\n    border-radius: 10px !important;\n}\n.videoClipTimestamp {\n    color: #007bff;\n    margin-top: 8px;\n    margin-bottom: 8px;\n    font-weight: bold;\n}\n\n.videoClip:hover {\n    box-shadow: 3px 5px 8px 1px rgba(0,0,0,0.5)\n}\n\n.dropdownDiv {\n    position: relative;\n    z-index: 4;\n}\n\n.videoClipDropdown {\n    position: absolute;\n    top: 1em;\n    right: 1em;\n}\n\n.button {\n    padding: 0px 5px 0px 5px;\n}\n\ninput[type=range]::-webkit-slider-thumb {\n    cursor: move;\n    cursor: grab;\n}\n\ninput[type=range]::-webkit-slider-thumb:active {\n    cursor: grabbing;\n}\n\ninput[type=range]::-moz-range-thumb {\n    cursor: move;\n    cursor: grab;\n}\n\ninput[type=range]::-moz-range-thumb:active {\n    cursor: grabbing;\n}\n\n\n/* My Videos CSS */\n.myVideos {\n    display: flex;\n    flex-direction: column;\n    min-height: 100%;\n    min-width: 100%;\n    padding-top: 1em;\n    padding-bottom: 1em;\n}\n\n.requiredForm label:after {\n    color: #e32;\n    content: ' *';\n    display: inline;\n    font-weight: bold;\n}\n\n\n.videoCards {\n    box-shadow: 3px 5px 8px 1px rgba(0,0,0,0.1);\n    max-width: 75vw;\n    margin-bottom: 1em;\n    border-radius: 10px !important;\n}\n\n.videoCards:hover {\n    box-shadow: 3px 5px 8px 1px rgba(0,0,0,0.5)\n}\n\n.videoCardImageDiv {\n    width: 100%;\n    overflow: hidden;\n    margin: 0;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n}\n\n.videoCardImage {\n    display: block;\n    width: 100%;\n    margin:-10% 0;\n}\n\n/*My ClipNotes CSS */\n.myClipNotes {\n    display: flex;\n    flex-direction: column;\n    min-height: 100%;\n    padding: 1em;\n}\n\n.card .card-header {\n    padding: 0;\n    height: 100%;\n    border: 0px;\n}\n\n.videoClipMagic {\n    flex-direction: column;\n}\n\n\n.videoClipSourceInfo {\n    flex-direction: row;\n    overflow: hidden;\n}\n\n.thumbnailSection {\n    flex-grow: 1;\n    max-width: 20%;\n}\n\n.titleSection {\n    flex: 20;\n    font-size: 80%;\n}\n\n.videoClipImageDiv {\n    overflow: hidden;\n    display: flex;\n    margin: 0;\n    border-top-left-radius: 10px;\n}\n\n.videoClipImage {\n    width: 100%;\n    margin:-10% 0;\n}\n\n.videoClipTitle {\n    padding: 0.5em 0em 0em 0.5em;\n}\n\n.selectDropdown {\n    z-index: 5;\n    margin-top: 1em;\n    margin-bottom: 1em;\n}\n\n/* Buttons */\n.playbackSpeedButton {\n    margin: 1px;\n}\n\n.setTimeButton {\n    height: 90%;\n    white-space: nowrap;\n    margin: 1px;\n}\n\n.submitClipButton {\n    margin-top: 10px;\n}\n\n\n/* Media Queries for Responsiveness */\n@media only screen and (max-width: 767px) {\n    .container {\n        max-width: 767px;\n    }\n\n    .videoPlayerControls {\n        display: none;\n    }\n\n    .clipControlsBottomFixed {\n        display: none !important;\n    }\n\n    .videoCards {\n        margin: 1em;\n    }\n\n    .homeNavContainer {\n        padding-bottom: 3em;\n    }\n}\n\n@media only screen and (min-width: 768px) {\n    .myVideos {\n        padding: 2em;\n    }\n\n    .videoClipMagic {\n        flex-direction: row;\n    }\n\n    .videoClipSourceInfo {\n        flex-direction: column;\n        max-height: none;\n        height: 100%;\n        max-width: 20em;\n    }\n\n    .videoInfoColumn {\n        -ms-flex: 0 0 16.666667%;\n        flex: 0 0 16.666667%;\n        max-width: 16.666667%;\n        flex-grow: 1;\n    }\n\n    .thumbnailSection {\n        flex-grow: unset;\n        min-width: 100%;\n    }\n\n    @container (inline-size < 700px) {\n        .videoClipMagic {\n            flex-direction: column;\n        }\n\n        .videoInfoColumn {\n            max-width: 100%;\n        }\n\n        .videoClipSourceInfo {\n            flex-direction: row;\n        }\n\n        .thumbnailSection {\n            min-width: 30%;\n        }\n    }\n\n    .videoClipColumn {\n        display: flex;\n        flex-direction: column;\n        flex: 3;\n    }\n\n    .videoClipCardBody {\n        flex-grow: 1;\n    }\n\n    .card .card-header {\n        border-right: 1px solid #d2d3d4;\n    }\n\n    .videoViewer {\n        flex: 1;\n    }\n\n    .videoPlayer {\n        padding: 1em 1em 0em 1em;\n        height: auto;\n        border-radius: 10px;\n        overflow: hidden;\n    }\n\n    .videoPlayerControls {\n        margin-bottom: 1em;\n    }\n\n    .clipControlsContainer {\n        margin: 0em 1em 0em 0em;\n        padding: 1em;\n        border: 1px solid #BEBBB5;\n        border-radius: 10px;\n    }\n\n    .clipControlsMidScroll {\n        padding: 0em 1em 0em 1em;\n        overflow: auto;\n        min-height: 300px;\n    }\n\n    .clipScrollDivHack {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n    }\n\n    .videoViewerMobileCTA {\n        display: none !important;\n    }\n\n    .videoCards {\n        max-width: 18rem;\n        margin: 1em;\n    }\n\n    .myClipNotes {\n        padding: 2em;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
